module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAJ1BMVEUAAACHh4eJiYmKioqKioqKioqKioqKioqLi4uKioqKioqKioqKioojvwVGAAAADHRSTlMAQIDt1M9VHrKqmZeSSCDEAAAAY0lEQVRIx+3TMQ2FUABD0Zv/QwhsOEAAAxLQgAIGBCAFQQggoaJw0G4M8I6F3vIVq4wZfrIWKlkTf1kjraweBhknUHfGRvEuYe4YTEwuRhuzj8eJ1ys+JlZ9yLigkbWXqh9zA0vXtNUd/FYZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/more.png
// module id = W5+0
// module chunks = 7